import React from 'react';
import PropTypes from 'prop-types';
import { isDevicePixelRatio2x, validateImageFileFormat } from '../../AmexMarketingUtils/AmexUtils';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import './AmexGDAB2BRestaurantExperience.scss';

const AmexGDAB2BRestaurantExperience = (
  {
    baseRequestUrl,
    getRestaurantExperienceComponentStatus,
    matchMedia,
    restaurantExperienceConfig: {
      content = {},
      images: {
        desktop: desktopImg = {},
        mobile: mobileImg = {},
        alt_resy_interface: altResyInterface = '',
      } = {},
      section_id: sectionId,
      subtitle,
      title,
    },
  }
) => {
  if (!title) {
    getRestaurantExperienceComponentStatus(false);
    return null;
  }
  const {
    card_1: textTop = '',
    card_2: textBottom = '',
  } = content;
  const imgPath = `${baseRequestUrl}AmexGDAB2B/images/RestaurantExperience/`;
  const imageType = matchMedia.lg ? desktopImg : mobileImg;
  const imageName = isDevicePixelRatio2x() ? imageType?.retina : imageType?.regular;
  const image = validateImageFileFormat(imageName);

  const sanitizedTitle = sanitizeString(title);
  const sanitizedSubtitle = sanitizeString(subtitle);
  const sanitizedTextTop = sanitizeString(textTop);
  const sanitizedTextBottom = sanitizeString(textBottom);

  return (
    <section className="AmexGDAB2BRestaurantExperience">
      <div className="container">
        <div className="AmexGDAB2BRestaurantExperience__wrapper">
          <h2
            id={sectionId}
            className="AmexGDAB2BRestaurantExperience__title"
            dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
              __html: sanitizedTitle,
            }}
          />
          {subtitle && (
            <p
              className="AmexGDAB2BRestaurantExperience__subtitle"
              dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                __html: sanitizedSubtitle,
              }}
            />
          )}
          <div className="AmexGDAB2BRestaurantExperience__img">
            {image && (
              <img
                className="AmexGDAB2BRestaurantExperience__img--interface"
                src={`${imgPath}${image}`}
                alt={altResyInterface}
              />
            )}
            {Object.keys(content).length > 0 && (
              <div className="AmexGDAB2BRestaurantExperience__content">
                <ul className="AmexGDAB2BRestaurantExperience__content--list">
                  {textTop && (
                    <li
                      className="item--top"
                      dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                        __html: sanitizedTextTop,
                      }}
                    />
                  )}
                  {textBottom && (
                    <li
                      className="item--bottom"
                      dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                        __html: sanitizedTextBottom,
                      }}
                    />
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

AmexGDAB2BRestaurantExperience.propTypes = {
  baseRequestUrl: PropTypes.string.isRequired,
  getRestaurantExperienceComponentStatus: PropTypes.func.isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    ipadLandscape: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  restaurantExperienceConfig: PropTypes.shape({
    content: PropTypes.shape({
      card_1: PropTypes.string,
      card_2: PropTypes.string,
    }).isRequired,
    images: PropTypes.shape({
      desktop: PropTypes.shape({}).isRequired,
      mobile: PropTypes.shape({}).isRequired,
      alt_resy_interface: PropTypes.string.isRequired,
    }).isRequired,
    section_id: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
};

export default AmexGDAB2BRestaurantExperience;
